export { default } from './category-posts-header';
